import React from 'react';
import { Input } from 'antd';

const regex = /^-?\d*(\.\d*)?$/;

const InputNumeric = ({
  style,
  onChange,
  value,
  onBlur,
  maxLength,
  disabled
}) => {
  const handleChange = (e) => {
    if (!onChange) {
      return;
    }
    const { value: inputValue } = e.target;

    if (regex.test(inputValue) || inputValue === '') {
      onChange(inputValue);
    }
  };

  return (
    <Input
      style={style}
      onChange={handleChange}
      value={value}
      onBlur={onBlur}
      maxLength={maxLength}
      disabled
    />
  );
};

export default InputNumeric;
